import { Directive, Input, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[type=text][noWhiteSpace]'
})
export class NoWhiteSpaceDirective {
  @Input() noWhiteSpace: "WIPE" | "TRIM" = "TRIM";

  constructor(private formControl: NgControl) { }

  @HostListener('keyup', ['$event.target'])
  onChange(inputText: HTMLInputElement) {
    const value = inputText.value;
    let valueWithoutSpaces = '';
    
    if (this.noWhiteSpace === "WIPE") {
      valueWithoutSpaces = value.replace(/\s/g, '');
    }
    else valueWithoutSpaces = value.trim();

    this.formControl.control?.setValue(valueWithoutSpaces);
  }
}
